import React from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyPage } from './EmptyPage';


const NotFound: React.FC = () => {
  const { t: translate } = useTranslation();

  return (
    <EmptyPage
      imageName="notFound"
      title={translate('common:httpStatus.notFound.title')}
      subtitle={translate('common:httpStatus.notFound.subtitle')}
    />
  );
};

export default NotFound;
